/**
 * Affiliations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    affiliations: [],
    affiliation: {}
};

// Getters
const getters = {
    affiliations: state => {
        return state.affiliations
    },

    affiliation: state => {
        return state.affiliation
    }
};

// Actions
const actions = {
    getAffiliations(context, payload) {
        function successCallback(response) {
            context.commit('getAffiliationsHandler', { affiliations: response.data.affiliations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getAffiliationsSouscripteur(context, payload) {
        function successCallback(response) {
            context.commit('getAffiliationsHandler', { affiliations: response.data });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.souscripteur, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getAffiliation(context, payload) {
        function successCallback(response) {
            context.commit('getAffiliationHandler', { affiliation: response.data.affiliation });
        }

        function errorCallback(error) {

            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.Get, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    createAffiliation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'affiliation', params: { affiliation: response.data.affiliation.slug } });
        }

        function errorCallback(error) {
            console.log("erreur pour affiliation: " + error);
            Vue.swal(
                error.data.error.dejaAffilie,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateAffiliation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'affiliation' });
            router.push({ name: 'affiliation', params: { affiliation: response.data.affiliation.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    updateAffiliationStatus(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            //store.dispatch('findAndRemove', {name: 'affiliation' });
            //router.push({ name: 'affiliation', params: { affiliation: response.data.affiliation.slug } });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.Status, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    deleteAffiliation(context, payload) {
        function successCallback(response) {
            context.commit('deleteAffiliationHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Affiliation.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getAffiliationsHandler(state, { affiliations }) {
        // Update affiliations state
        state.affiliations = affiliations;
    },

    getAffiliationHandler(state, { affiliation }) {
        // Update affiliation state
        state.affiliation = affiliation;
    },

    deleteAffiliationHandler(state, { index, successMessage }) {
        let i = state.affiliations.findIndex(affiliation => affiliation.slug === index);

        if (~i) {
            state.affiliations.splice(i, 1);

            router.push({ name: 'affiliations' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}